import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { WorkshopService } from "@/types";

const SERVICE_COLUMNS =
  "id, name, category, description, price, duration_minutes, active, created_at, updated_at";

export interface ServicesData {
  services: WorkshopService[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export function useServicesData(): ServicesData {
  const [services, setServices] = useState<WorkshopService[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("services")
        .select(SERVICE_COLUMNS)
        .order("created_at", { ascending: false });

      if (queryError) {
        setError("No se pudieron cargar los servicios.");
        setServices([]);
        return;
      }
      setServices((data ?? []) as WorkshopService[]);
    } catch {
      setError("No se pudieron cargar los servicios.");
      setServices([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { services, loading, error, reload: load };
}